import React from "react";
import Role from "../../types/Role";
import Department from "../../types/Department";
import Resources from "../../types/Resources";
import Button from "../Common/Button";

type UserRoleTableRowProps = {
    roleIndex: number;
    role: Role;
    resources: Resources;
    onRemoveUserRole: (role: Role) => void;
};

function UserRoleTableRow({ roleIndex, role, resources, onRemoveUserRole }: UserRoleTableRowProps) {
    return (
        <tr>
            <td>
                <input
                    type="hidden"
                    name={`CreateOrEditUserViewModel.UserViewModel.UserRoles[${roleIndex}].DepartmentId`}
                    value={role.departmentId}
                />
                {role.departmentName}
            </td>
            <td>
                <input
                    type="hidden"
                    name={`CreateOrEditUserViewModel.UserViewModel.UserRoles[${roleIndex}].RoleCode`}
                    value={role.roleCode}
                />
                {resources.get(role.roleCode)}
            </td>
            <td className="text-center">
                {role.canRemoveUserFromRole ? (
                    <Button variant="danger" onClick={() => onRemoveUserRole(role)}>
                        <i className="fas fa-trash-can"></i>
                    </Button>
                ) : null}
            </td>
        </tr>
    );
}

export default UserRoleTableRow;
